


const ResetPage:React.FC = () => {
  return(
    <div>ResetPage</div>
  )
}

export default ResetPage